import { API_ROOT } from 'packages/http_client/utils';

export const COHORT_API = `${API_ROOT}/cohort`;

export const COHORT_ID_API = `${COHORT_API}/{id}`;

export const PROGRAM_API = `${API_ROOT}/program`;
